import moment from 'moment';
import { FirebaseConfig, FirebaseCourseItem } from '../types/types';

export const canRegisterCourse = (
  course: FirebaseCourseItem,
  config: FirebaseConfig
) =>
  moment(course.startMoment).isSameOrBefore(
    moment().add(config.courseAllowedRegisterDays, 'days')
  );
